import { BrandAdTokenValue } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { brandAdTokenValuesUrl } from "./cmdGetBrandAdTokenValues";

/** A second value for the same ad token is a 409; blank is a 422. */
export class CommandCreateBrandAdTokenValue {
    async run(organizationId: string, brandId: string, adTokenUuid: string, value: string): Promise<BrandAdTokenValue> {
        return await httpRequest<BrandAdTokenValue>(brandAdTokenValuesUrl(organizationId, brandId), {
            method: "POST",
            body: { ad_token_definition: adTokenUuid, value },
        });
    }
}
